// extracted by mini-css-extract-plugin
module.exports = {"root":"DecisionItem-root-39e6f7dcff049301587e18abcd9d29f5","leftCol":"DecisionItem-leftCol-7f104c0e937546bb06ea0ce25d200cd1"};